import React from 'react'
import { Link } from 'react-router-dom';

import CTABackground from "../../assets/images/bg/cta.png";

export default function JoinSattva() {
    return (
        <section
            style={{ backgroundImage: `url(${CTABackground})` }}
            className="py-16 w-full table relative bg-center bg-cover">
            <div className="absolute inset-0 bg-black opacity-80"></div>
            <div className="container relative">
                <div className="grid grid-cols-1 pb-8 text-center">
                    <h3 className="mb-6 md:text-3xl text-2xl text-white font-medium">Join the SATTVA Movement</h3>
                    <p className="text-white opacity-50 max-w-xl mx-auto">Embrace the SATTVA spirit and become part of a global community dedicated to making a positive impact. Whether you are driven by the pursuit of a greener environment, empowered communities, or responsible governance, SATTVA is your guiding force towards a brighter and more sustainable future.</p>
                    <div className="relative mt-10">
                        <Link to="/contact" className="btn bg-blue-600 hover:bg-blue-700 border-blue-600 hover:border-blue-700 text-white rounded-md">Book a demo!</Link>
                    </div>
                </div>
            </div>
        </section>
    )
}
